// Responsável principal: é o que aparece no card da listagem (agendamento, tarefa, garantia, manutenção, entrega...).
// Regras: com um responsável só, ele é o principal; com vários, o principal é opcional, mas no máximo um.

export const ehPrincipal = (r) => !!(r?.responsavelPrincipal ?? r?.ResponsavelPrincipal);

// Texto do card: o nome do principal; sem principal e com vários, "N responsáveis"
export function textoResponsavelCard(lista, nomeDe) {
  const arr = Array.isArray(lista) ? lista : [];
  if (arr.length === 0) return '-';
  const principal = arr.find(ehPrincipal) || (arr.length === 1 ? arr[0] : null);
  if (principal) return nomeDe(principal) || '-';
  return `${arr.length} responsáveis`;
}

// Marca (tirando dos outros do mesmo dono) ou desmarca o principal no servidor
export function salvarPrincipal(apiCall, responsavelId, principal) {
  return apiCall(`Responsaveis/${responsavelId}/principal`, 'PUT', { principal: !!principal });
}
